import { IntlShape } from 'react-intl';
import { IEntityRoleDTO } from '../api/events.dao';
import { OperatorRole } from '../api/operators.dao';
import { NOT_LETTER_REG_EXP } from './regex.constants';

const deliveryMemberRoles = [
    'Co-Project Manager',
    'Event Producer',
    'Livestream Director',
    'Moderator',
    'Off Hours Lead',
    'Polling Expert',
    'Production Architect',
    'Production Lead',
    'Project Manager',
    'Studio Producer',
    'Other',
];

const ROLE_OPTIONS = Object.values(OperatorRole);

const getFormattedDeliveryMemberRoles = (intl: IntlShape): IEntityRoleDTO[] => deliveryMemberRoles.map(role => ({
        id: role.replace(NOT_LETTER_REG_EXP, '_').toUpperCase(),
        label: intl.formatMessage({
            id: `oe.deliveryTeamMemberRole.${role.replace(NOT_LETTER_REG_EXP, '')}`,
            description: 'Delivery team member role option',
            defaultMessage: role,
        }),
    })
);

const getFormattedOperatorRoles = (intl: IntlShape): IEntityRoleDTO[] => ROLE_OPTIONS.map(role => ({
        id: role,
        label: intl.formatMessage({
            id: `oe.operators.roleOptions.${role}`,
            description: 'Operator role option',
        }),
    })
);

export {
    getFormattedDeliveryMemberRoles,
    getFormattedOperatorRoles,
};
